import { useState } from 'react';
import './tailwind.css';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/Reporting/ui/card';
import ReportForm from '../../components/Reporting/report-form';
import PosReports from '../../components/Reporting/pos-reports';
import PosPerformanceOutput from '../../components/Reporting/pos-performance-output';
import { HeaderMenu } from '../../components/Reporting/header-menu';
import instance from '../../services/api';
import { toast } from 'react-toastify';
import PagePrintPreview from 'components/Reporting/page-print-preview';
import ThermalPrintView from 'components/Reporting/thermal-print-view';
import { Store } from 'lucide-react';
import { EXCLUDED_DELIVERY_REPORT_SECTIONS } from '../../components/Reporting/shared/schema';

const DELIVERY_REPORT_ORDER_TYPES = [
  'phone_order_delivery',
  'catering_delivery',
  'delivery',
];

export default function DeliveryReportsPage() {
  const [reportData, setReportData] = useState(null);
  const [include, setInclude] = useState(undefined);
  const [tenderTypes, setTenderTypes] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [show80mmView, setShow80mmView] = useState(false);
  const [showPagePreview, setShowPagePreview] = useState(false);

  const handlePrint = () => {
    setShowPagePreview(true);
  };

  const handleFormSubmit = async (data) => {
    setIsLoading(true);
    try {
      const response = await instance.post('/reports/pos-performance', {
        ...data,
        orderTypes: DELIVERY_REPORT_ORDER_TYPES,
      });
      setInclude(data.include);
      setTenderTypes(data.tenderTypes);
      setReportData(response.data);
      toast.success('Delivery Report Generated Successfully');

      // Scroll to report output
      setTimeout(() => {
        document.getElementById('pos-reports')?.scrollIntoView({
          behavior: 'smooth',
        });
      }, 100);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        'Failed to generate POS reports. Please try again.';
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handle80mmPrint = () => {
    setShow80mmView(true);
  };

  return (
    <div className="min-h-screen bg-background">
      <HeaderMenu
        currentPage="delivery"
        reportData={reportData}
        onPrint={handlePrint}
        on80mmPrint={handle80mmPrint}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Report Form */}
        <Card className="no-print mb-8">
          <CardHeader>
            <CardTitle className="flex items-center">
              <Store className="text-primary mr-3 h-6 w-6" />
              Generate Delivery Report
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ReportForm
              onSubmit={handleFormSubmit}
              isLoading={isLoading}
              showPaymentMethods
              excludedIncludeSections={EXCLUDED_DELIVERY_REPORT_SECTIONS}
            />
          </CardContent>
        </Card>

        {/* POS Reports Output */}
        {reportData && (
          <div id="pos-reports" className="space-y-8">
            {/* Use PosPerformanceOutput for new API structure */}
            {reportData.todaysTotalOrders !== undefined ? (
              <PosPerformanceOutput
                data={reportData}
                isDeliveryReport
                include={include}
                tenderTypes={tenderTypes}
              />
            ) : (
              <PosReports data={reportData} />
            )}
          </div>
        )}
      </div>

      {/* 80mm Thermal Print View */}
      {show80mmView && reportData && (
        <ThermalPrintView
          data={reportData}
          tenderTypes={tenderTypes}
          onClose={() => setShow80mmView(false)}
        />
      )}

      {/* Full Page Print Preview */}
      {showPagePreview && reportData && (
        <PagePrintPreview
          data={reportData}
          contentSelector="#pos-reports"
          onClose={() => setShowPagePreview(false)}
          reportType="POS-Performance-Delivery"
        />
      )}
    </div>
  );
}
